import React, { useContext, useEffect, useState } from 'react';

export enum Entities {
  CUSTOMER = 'customer',
  TICKET = 'ticket',
  APPOINTMENT = 'appointment'
}

export const DrawerContext = React.createContext<{
  showDrawer: (entity: keyof typeof Entities, id: number) => void;
  hideDrawer: () => void;
  setDrawerMode: (drawerMode: boolean) => void;
  drawerMode: boolean;
  isOpen?: boolean;
  entity?: keyof typeof Entities;
  id?: number;
} | null>(null);

export type DrawerProviderProps = { children: React.ReactNode };

export const DrawerProvider: React.FC<DrawerProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [entityId, setEntityId] = useState<number | null>(null);
  const [entity, setEntity] = useState<keyof typeof Entities | null>(null);
  const [drawerMode, setDrawerMode] = useState<boolean>(true);

  return (
    <DrawerContext.Provider
      value={{
        showDrawer: (entity: keyof typeof Entities, id: number) => {
          if (isOpen && entityId === id) {
            setIsOpen(false);
            setEntity(null);
            setEntityId(null);
          } else {
            setEntity(entity);
            setEntityId(id);
            setIsOpen(true);
          }
        },
        hideDrawer: () => {
          setIsOpen(false);
          setEntity(null);
          setEntityId(null);
        },
        setDrawerMode: drawerMode => {
          setDrawerMode(drawerMode);
        },
        drawerMode,
        entity,
        id: entityId,
        isOpen
      }}
    >
      {children}
    </DrawerContext.Provider>
  );
};

export const useDrawer = () => useContext(DrawerContext);
